import { useMemo } from "react";
import { useResult } from "2g-grid";

import { useTypyZdroje } from "b2b/api/hooks";
import useMessages from "./i18n/useMessages";
import useColumns from "./useColumns";

export default function useZdrojeTypyGrid() {
  const columns = useColumns();
  const loader = useTypyZdroje();
  const messages = useMessages();

  const data = useMemo(
    () => loader.data?.map(item => item.typZdroje),
    [loader.data]
  );

  return {
    ...useResult({
      title: messages.pageHeading(),
      data: data,
      columns,
      showFilterDescription: false,
      selectable: false,
      sortable: true
    }),
    loading: loader.loading
  };
}
